const tabRow = "inline-flex max-w-full flex-wrap rounded-lg border border-border bg-card p-1 gap-1 mb-6";

const tabButton = "inline-flex min-w-0 max-w-full items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-colors";

const tabActive = "bg-primary text-primary-foreground";

const tabElectricityActive = `${tabButton} ${tabActive}`;

const tabWaterActive = `${tabButton} ${tabActive}`;

const tabButtonInactive = `${tabButton} text-muted-foreground hover:text-foreground`;

const uploadingIcon = "h-10 w-10 text-muted-foreground animate-spin";

const section = "space-y-6";

const card = "rounded-xl border border-border bg-card shadow-card transition-all duration-200 hover:border-primary/30 p-4 sm:p-6";

const cardTitle = "text-lg font-semibold text-foreground mb-1";

const cardDescription = "text-sm text-muted-foreground mb-4";

const uploadArea =
  "flex flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed border-border bg-background/50 px-6 py-10 text-center cursor-pointer hover:border-primary/50 hover:bg-primary/5 transition-colors";

const uploadIcon = "h-10 w-10 text-muted-foreground";

const photoPreview = "max-h-64 rounded-lg border border-border object-contain";

const reviewGrid = "grid grid-cols-1 sm:grid-cols-2 gap-4";

const fieldGroup = "space-y-1.5";

const input =
  "w-full rounded-lg border bg-background px-3 py-2 text-sm border-border focus:outline-none focus:ring-2 focus:ring-ring placeholder:text-muted-foreground/60 disabled:opacity-50";

const valueText = "text-sm text-muted-foreground break-words";

const badgeRow = "flex items-center gap-2 flex-wrap";

const badge = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium";

const badgeHigh = `${badge} bg-success/10 text-success`;

const badgeMedium = `${badge} bg-warning/10 text-warning`;

const badgeLow = `${badge} bg-destructive/10 text-destructive`;

const actionRow = "flex items-center gap-3 pt-4 border-t border-border/60";

const primaryButton =
  "inline-flex items-center gap-2 rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:pointer-events-none";

const secondaryButton =
  "inline-flex items-center gap-2 rounded-lg border border-border bg-background text-muted-foreground px-4 py-2 text-sm font-medium hover:bg-accent transition-colors disabled:opacity-50 disabled:pointer-events-none";

const form = "space-y-4 max-w-md";

const formActions = "flex gap-2 pt-4";

const saveButton =
  "self-start rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:pointer-events-none";

const historyList = "space-y-2";

const historyItem = "flex items-center justify-between rounded-lg border border-border bg-background px-4 py-3";

const historyError = "text-xs text-destructive mt-1";

const success = "text-sm text-success";

const spinner = "h-4 w-4 animate-spin";

const warning = "text-sm text-warning";

export {
  actionRow,
  badgeHigh,
  badgeLow,
  badgeMedium,
  badgeRow,
  card,
  cardDescription,
  cardTitle,
  fieldGroup,
  form,
  formActions,
  historyError,
  historyItem,
  historyList,
  input,
  photoPreview,
  primaryButton,
  reviewGrid,
  saveButton,
  secondaryButton,
  section,
  spinner,
  success,
  tabElectricityActive,
  tabWaterActive,
  tabButtonInactive,
  tabRow,
  uploadArea,
  uploadIcon,
  uploadingIcon,
  valueText,
  warning,
};
